import { IWall } from "../models/wall";
import { User } from "../models/user";
import { IPost } from "../models/post";
import { IComment } from "../models/comment";
import { wallReducer } from "./wall";
import { postReducer, pendingPostReducer } from "./post";
import {featuredPostReducer} from "./feature.post";
import { commentReducer } from "./comment";
import { userReducer, usersReducer } from "./user";
import {combineReducers} from "redux";
import { ITag } from "../models/tag";
import { tagReducer } from "./tag";
import {IAlert} from "../models/alert";
import {alertReducer} from "./alert";
import {keyReducer} from './key';
import {eventReducer} from './edu.events';

interface Store {
    walls:[IWall] | null;
    user: User;
    posts: [IPost] | null;
    comments: [IComment] | null;
    featuredPosts: [IPost] | null;
    tags: [ITag] | null;
    alerts: [IAlert] | null;
    pendingPosts: [IPost] | null;
    users: any;
    keys: any;
    events: any;
}
export const rootReducer = combineReducers<Store>({
    walls: wallReducer, 
    posts: postReducer, 
    comments: commentReducer, 
    user: userReducer, 
    featuredPosts: featuredPostReducer, 
    tags: tagReducer, 
    alerts: alertReducer, 
    pendingPosts: pendingPostReducer, 
    users: usersReducer,
    keys: keyReducer,
    events: eventReducer
});